<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation('S430', 'en-US')"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="height:100%; margin-bottom: 0px !important"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          <!--{{ uniTranslation("S430") }} -->
          {{ uniTranslation(cardLabel) }}
        </div>

        <!--el-tabs
          v-model="tabSelezionata"
          type="border-card"
          :style="{ backgroundColor: coloreSfondoTab, color: coloreTestoTab + '!important' }"
          @tab-click="cambiaTab"
        >
        <el-tab-pane label="Input" name="Input"-->
        <FluidPicker :path="path"></FluidPicker>

        <UnidataEditor
          :parent-path="path"
          :name="'.flow'"
          :show-input="1"
          :show-output1="!modalitaSimulation ? 1 : 0"
          :override-input-class="modalitaSimulation ? 'col-12' : undefined"
          :override-output1-class="undefined"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.inletTemperature'"
          :show-input="1"
          :show-output1="!modalitaSimulation ? 1 : 0"
          :override-input-class="modalitaSimulation ? 'col-12' : undefined"
          :override-output1-class="undefined"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.outletTemperature'"
          :show-input="!modalitaSimulation ? 1 : 0"
          :show-output1="1"
          :override-input-class="undefined"
          :override-output1-class="modalitaSimulation ? 'col-12' : undefined"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.pressureDrop'"
          :um-not-show="'bar G'"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.operatingPressure'"
          :auto-decimals="4"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.foulingFactor'"
          :auto-decimals="8"
          :min="0"
        ></UnidataEditor>

        <span v-if="bMostraOutput">
          <p>&nbsp;</p>
          <!--/el-tab-pane>
          <el-tab-pane label="Output" name="Output"-->
          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.pressureDropConnections'"
              :auto-decimals="4"
            ></UnidataEditor>
          </div>
          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.fluidVelocityConnections'"
              :auto-decimals="4"
            ></UnidataEditor>
          </div>

          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.fluidVelocityChannel'"
              :auto-decimals="4"
            ></UnidataEditor>
          </div>

          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.reynolds'"
              :fixed-decimals="0"
            ></UnidataEditor>
          </div>

          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.heatTransferCoefficient'"
              :auto-decimals="4"
            ></UnidataEditor>
          </div>

          <div>
            <UnidataEditor
              :parent-path="path"
              :name="'.shearIndex'"
              :fixed-decimals="2"
            ></UnidataEditor>
          </div>
          <!--/el-tab-pane>
          </el-tabs-->
        </span>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FluidPicker from "../shared/FluidPicker";
import UnidataEditor from "../unidata/UnidataEditor";
// import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
// import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import { mapGetters } from "vuex";
import /*Radio, Collapse, CollapseItem, Tabs, TabPane*/ "element-ui";
// import jsonHelper from "../../shared/jsonHelper";
import colorsService from "../../services/backend/colorsService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    FluidPicker,
    UnidataEditor
    /* UnidataEditorCorrelator,
    UnidataEditorCorrelatorOptionList,*/
    /* "el-tabs": Tabs,
    "el-tab-pane": TabPane /*,
    "el-radio": Radio,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      modalitaSimulation: false,
      tabSelezionata: "Input",
      coloreSfondo: "",
      coloreTesto: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreSfondoTab: "",
      coloreTestoTab: "",
      coloreBordo: "",
      cardLabel: "",
      unsubscribes: []
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    bMostraOutput: function() {
      if (this.$store.getters.status_Verifica) {
        return this.$store.getters.status_PostCalcolo;
      } else if (this.$store.getters.status_Selezione) {
        return this.$store.getters.status_PostCalcolo;
      } else {
        return false;
      }
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;

    that.unsubscribes.push(
      that.$store.subscribe(function(mutation) {
        if (mutation.type === "changeProjectProperty") {
          if (mutation.payload.path.startsWith(that.parentPath + ".shoulder.idCalculationType")) {
            if (mutation.payload.value == 3) {
              that.modalitaSimulation = true;
            } else {
              that.modalitaSimulation = false;
            }
          }
        }
      })
    );

    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = colorList[1];
    that.coloreTesto = colorList[2];
    that.coloreTitolo = colorList[3];
    that.coloreSfondoTab = colorList[4];
    that.coloreTestoTab = colorList[5];
    that.coloreBordo = colorList[6];
    let specificHeaderBackColor = jsonHelper.getProperty(
      that.projects,
      that.path + ".cardHeaderBackColor"
    );
    if (specificHeaderBackColor) {
      that.coloreBarraTitolo = specificHeaderBackColor;
    }
    let specificHeaderTextColor = jsonHelper.getProperty(
      that.projects,
      that.path + ".cardHeaderTextColor"
    );
    if (specificHeaderTextColor) {
      that.colorecoloreTesto = specificHeaderTextColor;
    }
    let specificCardLabel = jsonHelper.getProperty(that.projects, that.path + ".cardHeaderLabel");
    if (specificCardLabel) {
      that.cardLabel = specificCardLabel;
    }
    //});
  },
  methods: {}
};
</script>

<style>
.card .card-header {
  color: transparent;
  background-color: transparent;
  padding: 0px;
}

.el-tabs__item:hover {
  color: #409eff !important;
}
.el-tabs__item {
  background-color: transparent !important;
  color: unset !important;
}
.el-tabs__header {
  background-color: transparent !important;
  color: unset !important;
}
.is-active {
  background-color: transparent;
  color: unset !important;
  font-weight: bold;
}
.el-tabs--border-card {
  color: transparent;
}
.el-tabs .el-tabs--top {
  color: transparent !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #409eff !important;
  background-color: #fff !important;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-active):not(:hover) {
  color: #909399 !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  border-top-color: transparent;
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: transparent;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: transparent;
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  margin: -1px -1px 0;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  margin: 0;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa !important;
  border-bottom: 1px solid #e4e7ed;
  margin: 0;
}
</style>
